import { render, staticRenderFns } from "./DailyReportPage.vue?vue&type=template&id=4cffe70f&scoped=true&"
import script from "./DailyReportPage.vue?vue&type=script&lang=js&"
export * from "./DailyReportPage.vue?vue&type=script&lang=js&"
import style0 from "./DailyReportPage.vue?vue&type=style&index=0&id=4cffe70f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffe70f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cffe70f')) {
      api.createRecord('4cffe70f', component.options)
    } else {
      api.reload('4cffe70f', component.options)
    }
    module.hot.accept("./DailyReportPage.vue?vue&type=template&id=4cffe70f&scoped=true&", function () {
      api.rerender('4cffe70f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DailyReportPage.vue"
export default component.exports